module.exports = __webpack_public_path__ + "static/media/clientes.9bccb928.png";